module.exports = __webpack_public_path__ + "img/api-explorer.434fb796.svg";